import { render, staticRenderFns } from "./SettingsAlert.vue?vue&type=template&id=35584bba&scoped=true"
import script from "./SettingsAlert.vue?vue&type=script&lang=ts"
export * from "./SettingsAlert.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAlert.vue?vue&type=style&index=0&id=35584bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35584bba",
  null
  
)

export default component.exports